<app-header></app-header>
<main id="content">
  <section id="home">
    <div [ngStyle]="{'background': '#464646 url(' + currentPathObj.image + ')'}" class="hero hero-home"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 padding-left">
          <p class="text text-xxl">Welcome Back, {{userObj.first_name}} {{userObj.last_name}}</p>
        </div>
      </div>
      <div class="row current-path" *ngIf="currentPathObj.status">
        <div class="col-md-7 col-md-offset-1">
          <div class="row current-path-info">
            <div class="col-md-3 col-xs-3">
              <div class="progress-circle">
                <div class="wrap svg-view">
                  <p>
                    <span>{{currentPathObj.status.exercises_completed_percentage}}%</span>
                    <span>complete</span>
                  </p>
                  <!-- <svg viewBox="-10 -10 220 220" #svgPath>
                    <path d="M200,100 C200,44 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z" stroke-dashoffset='-566' stroke-linecap="round" data-circle-type="percentage"></path>
                  </svg> -->
                </div>
              </div>
            </div>
            <div class="col-md-8 col-md-offset-1 col-xs-9">
              <div class="label label-underline">my current path</div>
              <a href="/#/paths/{{currentPathObj.id}}">
                <h1 class="heading heading-lg">{{currentPathObj.name}}</h1>
              </a>
              <p class="text text-md">
                <span>{{currentPathObj.short_description}}</span>
                <a href="/#/paths/{{currentPathObj.id}}">View the path</a>
              </p>
              <div data-view="socialPanel"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row exercise" *ngIf="activeExerciseObj.description">
        <div class="col-md-1 col-sm-2 col-xs-2 first-exercise-icon">
          <div class="icon-container">
            <i class="fa fa-arrow-right"></i>
          </div>
        </div>
        <div class="col-md-7 col-sm-10 col-xs-10 first-exercise">
          <div class="row">
            <div class="col-md-2 col-xs-2">
              <img src="/assets/images/doctor.svg" alt="doctor img" class="image">
            </div>
            <div class="col-md-10 col-xs-10">
              <div class="col-md-2 col-xs-2">
                <span>#{{activeExerciseObj.sequence}}</span>
              </div>
              <div class="col-md-10 col-xs-10">
                <a href="/#/exercise/{{activeExerciseObj.id}}" class="link block">
                  <h3 class="heading heading-sm heading-underline">{{activeExerciseObj.name}}</h3>
                </a>
                <p class="text text-md"> {{ (activeExerciseObj.description.length>100) ? (activeExerciseObj.description | slice:0:100 )+'...' : (activeExerciseObj.description)}}
                  <a href="/#/exercise/{{activeExerciseObj.id}}" data-action="expandText">more</a>
                </p>
                <a href="/#/exercise/current/ongoing" class="btn btn-inline btn-lg btn-primary text-uppercase">do your next exercise</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-8 col-xs-8 quick-meditation fill-right no-p-left no-p-right" *ngIf="activeExerciseObj.description">
          <div class="row flex-row middle">
            <div class="col-md-4 col-xs-3">
              <img src="/assets/images/monk.png" alt="monk image" [ngClass]="{'imgFix-mac': alignFix}">
            </div>
            <div class="col-md-8 col-xs-9 text-right" [ngClass]="{'alignFix-mac': alignFix}">
              <p class="text text-lg">Or just take a break and</p>
              <p class="text text-xl text-uppercase">
                <a role="button" href="/#/single-meditation" class="group">do a quick meditation
                  <i class="fa fa-arrow-right"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row third-row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-12 exercise-list fill-left">
              <div class="exercise-heading" *ngIf="lockedExercisesObj.length > 0">
                <div class="row">
                  <div class="col-md-2 col-xs-2"></div>
                  <div class="col-md-10 col-xs-10 col-md-offset-2 no-p-left">
                    <h2 class="heading-md heading-underline orange">What comes next</h2>
                  </div>
                </div>
              </div>
              <div data-status="locked" class="exercise" *ngFor="let locked of lockedExercisesObj">
                <div class="row">
                  <div class="col-md-2 col-sm-2 col-xs-2 text-right">
                    <div class="icon-container">
                      <i class="fa fa-lock"></i>
                      <span>#{{locked.sequence}}</span>
                    </div>
                  </div>
                  <div class="col-md-10 col-sm-10 col-xs-10">
                    <a href="/#/exercise/{{locked.id}}" class="link block">
                      <h3 class="heading heading-md heading-underline">{{locked.name}}</h3>
                    </a>
                    <span class="exercise-status">locked</span>
                  </div>
                </div>
              </div>
              <div class="exercise-heading" *ngIf="completedExercisesObj.length > 0">
                <div class="row">
                  <div class="col-md-2 col-sm-2 col-xs-2"></div>
                  <div class="col-md-10 col-sm-10 col-xs-10 col-md-offset-2 no-p-left">
                    <h2 class="heading-md heading-underline orange">Completed exercises</h2>
                  </div>
                </div>
              </div>
              <div data-status="completed" class="exercise" *ngFor="let completed of completedExercisesObj">
                <div class="row">
                  <div class="col-md-2 col-sm-2 col-xs-2 text-right">
                    <div class="icon-container">
                      <i class="fa fa-check"></i>
                      <span>#{{completed.sequence}}</span>
                    </div>
                  </div>
                  <div class="col-md-10 col-sm-10 col-xs-10">
                    <a href="/#/exercise/{{completed.id}}" class="link block">
                      <h3 class="heading heading-md heading-underline">{{completed.name}}</h3>
                    </a>
                    <span class="exercise-status">completed on {{completed.formatedDate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 no-p-left no-p-right">
          <div data-view="user-achievements"></div>
          <section id="home-community" class="fill-right">
            <div class="row">
              <div class="col-md-12">
                <div class="post-list" *ngIf="postsObj.length > 0">
                  <div class="home-community-post" *ngFor="let post of postsObj">
                    <div class="row align-tab">
                      <div class="col-md-2">
                        <div class="avatar avatar-sm">
                          <img src="/assets/images/default_avatar.png" alt="avatar">
                        </div>
                      </div>
                      <div class="col-md-10">
                        <p class="post-creator-name">{{post.user.full_name}}</p>
                        <span class="post-date">{{post.convertedDate}}</span>
                        <div class="post-content">
                          <div class="post-attachment">
                            <img src="{{post.attachment}}" alt="">
                          </div>
                          <div class="post-message text text-md">{{post.message}}</div>
                          <div data-view="socialPanel"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</main>
<app-dailyquotes></app-dailyquotes>
<app-footer></app-footer>
<app-menu></app-menu>
<app-tutorial></app-tutorial>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/home/home.component.html